<template>
  <div v-if="allTagsDisplayed" class="tw-flex tw-flex-wrap">
    <WdsTag
      v-for="tag in props.tags"
      :key="tag.label"
      :primary="tag.primary"
      :label="tag.label"
      class="tw-mr-2 tw-mt-2 tw-cursor-pointer"
      sm
    />
  </div>
  <div v-else class="tw-flex tw-flex-wrap">
    <WdsTagGroup
      :tags="tags"
      sm
      :max-tags="3"
      class="tw-cursor-pointer"
      @click.prevent="allTagsDisplayed = true"
    />
  </div>
</template>

<script setup lang="ts">
import {PropType, ref} from 'vue'
import { WdsTag, WdsTagGroup } from '@worksome/wds-components'

const props = defineProps({
  tags: {
    type: Array as PropType<{
      label: string,
      primary: boolean,
    }[]>,
    required: true,
  },
})

const allTagsDisplayed = ref(false);
</script>
